import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { PayPalEffects } from './paypal.effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([PayPalEffects])],
})
export class PayPalModule {}
